/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SaveCouponEnrollmentLinksRequestViewModel } from "../types/SaveCouponEnrollmentLinksRequestViewModel.ts";

export const saveCouponEnrollmentLinksRequestViewModelSchema = z.object({
  classStudentIds: z
    .array(z.number().int())
    .describe(
      "IDs das turmas a vincular ao cupom. A lista substitui integralmente o vínculo anterior; lista vazia remove todos.",
    )
    .nullish(),
}) as unknown as ToZod<SaveCouponEnrollmentLinksRequestViewModel>;
